import type { AppContext, AppProps, NextWebVitalsMetric } from 'next/app'
import { appWithTranslation } from 'next-i18next'

import { ErrorBoundary } from 'modules/utils/ErrorBoundary'
import { start } from 'utils/bugsnag'
import nextI18NextConfig from '../../next-i18next.config'
import App from 'next/app'

const isDevEnv =
  process.env.NEXT_PUBLIC_APP_ENV === 'local' || process.env.NEXT_PUBLIC_APP_APP_ENV === 'dev'

export function reportWebVitals(metric: NextWebVitalsMetric) {
  isDevEnv && console.info(metric)
}

// Initialize Bugsnag
start()

const MyApp = ({ Component, pageProps }: AppProps) => {
  return (
    <ErrorBoundary>
      <Component {...pageProps} />
    </ErrorBoundary>
  )
}

MyApp.getInitialProps = async (context: AppContext) => {
  const ctx = await App.getInitialProps(context)

  return ctx
}

export default appWithTranslation(MyApp, nextI18NextConfig)
